<template>
  <div class="container">
    <div class="container-pdf card-make-content">
      <div class="preview-wrapper">
      <div id="preview-page-wrap">
      <div id="down-pdf">
      </div>
      </div>
      </div>
    </div>
    <Header></Header>
    <div class="cont-list">
      <div class="tool">
        <el-button type="primary" @click="addAcCrad">新建答题卡</el-button>
        <el-button type="primary" @click="handleDocUpload">导入试卷制卡</el-button>
        <el-button @click="handleImport">导入</el-button>
        <div class="search">
          <div class="input-with-select">
            <el-input
              placeholder="请输入内容"
              v-model="param.searchVal"
              @keyup.native.enter="searchAcCardList"
            >
              <el-button slot="append" type="primary" icon="el-icon-search"  @click="searchAcCardList"></el-button>
            </el-input>
          </div>
          <el-select
            v-model="param.typeVal"
            slot="prepend"
            @change="searchAcCardList"
            placeholder="全部类型"
          >
            <template v-for=" item in typeList">
              <el-option :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </template>
          </el-select>
        </div>
      </div>
      <el-table :data="tableData" border v-loading="tableLoading" style="width: 100%;margin-top: 15px" :header-cell-style="{background:'rgb(241 241 241)',color:'#606266'}">
         <!-- <el-table-column
      type="index"
      :index="indexMethod">
    </el-table-column> -->
        <el-table-column min-width="300" align="left" label="名称" >
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-between">
              <p style="font-size: 14px;width: 60% " v-html="scope.row.acCardName"></p>
            <!-- <p class="c-gray c-small">{{'答题卡ID：' + scope.row.acCardId}}</p> -->
            <div>
            <el-tag style="width: 124px;margin-right:10px;">{{ scope.row.acCardPanes }}</el-tag>
            <el-tag type="success">{{scope.row.acCardYJType}}</el-tag>
            </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="75"  label="类型" >
          <template slot-scope="scope">
            <!-- <div
              class="custom-tge green"
              style="width:78px;"
              v-if="scope.row.acCardDJType === '自制'"
            >自制</div>
            <div class="custom-tge yellow" style="width:78px;" v-else>组卷</div> -->
            <p style="font-size: 14px ;width:78px;" >{{scope.row.acCardDJType}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="v6" label="创建时间" min-width="120">
          <template slot-scope="scope">
            <!-- <p class="c-gray c-small">创建时间：</p> -->
            <p class="c-gray">{{scope.row.acCardCreateTime}}</p>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" @click="del(scope.row)">删除</el-button>
            <el-button type="text" :disabled="!scope.row.isdown" @click="down(scope.row)">下载</el-button>
            <!-- <el-button type="text" @click="reuse(scope.row)">复用</el-button> -->
            <!-- <el-button  @click="reuse(scope.row)">更多</el-button> -->
            <el-popover
              placement="bottom"
              width="62"
              trigger="hover"
              popper-class="more-wrap"
              >
              <div class="operation-ul">
                <span  @click="handlerDownloadWord(scope.row)" class="mb" v-if="scope.row.acCardDJType == '试卷导入'">下载试卷</span>
                <span  @click="reuse(scope.row)" class="mb">复用</span>
                <span  @click="handleMbAdd(scope.row)" class="mb">设为模板</span>
                <span @click="handleShare(scope.row)">分享</span>
              </div>
              <el-button type="text" slot="reference" style="margin-left: 10px;">
                <span>更多</span>
                <i class="el-icon-caret-bottom"></i></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <div>
            <img src="@/assets/images/400.png" alt="">
            <div style="text-align: center">暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-pagination
        class="pagination-card"
        @current-change="pageCurrentChange"
        @size-change="sizeCurrentChange"
        :current-page="param.pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="param.pageSize"
        layout="total, sizes,prev, pager, next,  jumper"
        :total="pageTotal"
      ></el-pagination>
      <!-- 新建答题卡制作弹框 -->
      <ac-dialog v-model="acDialogV"></ac-dialog>
      <!-- 新建答题卡制作弹框end -->
      <!-- 设置为模板弹窗 -->
      <ModalTemplateAdd v-model="modalMbAddV"  :params="modalTemplateAddParams"/>
      <!-- 设置为模板弹窗end -->
      <!-- 答题卡导入弹窗 -->
      <ModalImport v-model="modalImportV" @onSuccess="handleSuccessImport"/>
      <!-- 答题卡导入弹窗 -->
      <!-- 答题卡分享弹窗 -->
      <ModalShare v-model="modalShareV"  :acCardName="modalShareName" :shareCode="modalShareCode" />
      <!-- 答题卡分享弹窗end -->
      <!-- 答题卡试卷制卡弹窗 -->
      <ModalDocUpload v-model="modalDocUploadV"/>
      <!-- 答题卡试卷制卡弹窗end -->
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import AcCardApi from "@/services/acCard";
import AcDialog from "./components/AcDialog";
import ModalTemplateAdd from './components/home/modal-template-add'
import ModalImport from './components/home/modal-import'
import ModalShare from './components/home/modal-share'
import ModalDocUpload from './components/home/modal-doc-upload'
import $ from "jquery";
import JsPDF from "jspdf";
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  name: "Home",
  components: {
    Header,
    AcDialog,
    ModalTemplateAdd,
    ModalImport,
    ModalShare,
    ModalDocUpload
  },
  data() {
    return {
      acDialogV: false, //控制新建DTK弹框开关
      modalMbAddV: false,
      modalImportV: false,
      modalShareV: false,
      modalDocUploadV: false,
      modalShareName: '',
      modalShareCode: '',
      // 以上是弹窗的参数
      modalTemplateAddParams: {},
      param: {
        pageSize: 10,
        pageIndex: 1,
        typeVal: "",
        searchVal: "",
      }, //列表参数
      pageTotal: 4,
      typeList: [],
      tableLoading: false,
      tableData: [], //列表数据
      layerList: [
        {
          lay: false,
        },
      ],
    };
  },
  mounted() {
    this.getAcCardList();
    this.getAcCardTypeList();
    this.getKMAndPeriod();
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("card", {
      pageCell: (state) => state.pageCell, //纸张的数据
      subjects: (state) => state.subjects, //纸张的数据
      pageCellCopy: (state) => state.pageCellCopy, //纸张的数据
  }),
  },
  methods: {
    ...mapMutations({
      setkMAndPeriod: "card/setkMAndPeriod",
    }),
    // 答卷列表
    getAcCardList() {
      const params = {
        pageIndex: this.param.pageIndex,
        pageSize: this.param.pageSize,
        acCardDJType: this.param.typeVal === 9999 ? "" : this.param.typeVal,
        acCardName: this.param.searchVal || "",
      };
      this.tableLoading = true;
      AcCardApi.GetAcCardList(params)
        .then((res) => {
          if (res.status === 200) {
            this.tableData = (res.data && res.data.list) || [];
            this.pageTotal = (res.data && res.data.count) || 0;
            this.tableLoading = false;
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    searchAcCardList() {
      this.param.pageIndex = 1;
      this.getAcCardList();
    },
    // 答题卡类型
    getAcCardTypeList() {
      AcCardApi.GetAcCardTypeList({}).then((res) => {
        if (res.status === 200) {
          this.typeList = (res.data && res.data.TypeList) || [];
          this.typeList.unshift({ Id: 9999, Name: "全部类型" });
          this.param.typeVal = 9999;
        }
      });
    },
    getKMAndPeriod() {
      AcCardApi.GetKMAndPeriod({}).then(res => {
        if(res.status === 200) {
          const myKMAndPeriod = {
          KM: res.data.KM && res.data.KM.map((item) => {
            return {
              label: item.Name,
              value: item.Id
            }
          }),
          Period: res.data.Period && res.data.Period.map((item) => {
            return {
              label: item.Name,
              value: item.Id
            }
          }),
        } 
        this.setkMAndPeriod(myKMAndPeriod || {KM: [], Period: []});
      }

      })
    },
    // 编辑答卷
    edit(row) {
      this.$router.push({ path: "/card", query: { guid: row.acCardGuid } });
    },
    // 删除答卷
    del(row) {
      this.$confirm(
        "注意，删除答卷信息后阅卷设置将无法快速关联答题卡参数, 是否删除?",
        "确认删除",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        AcCardApi.DeleteAcCard({ acCardGuid: row.acCardGuid }).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getAcCardList();
          }
        });
      });
    },
    // 复用答卷
    reuse(row) {
      this.$confirm("是否复用此答题卡?", "确认复用", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        AcCardApi.MultiplexAcCard({ acCardGuid: row.acCardGuid }).then(
          (res) => {
            if (res.status === 200) {
              this.getAcCardList();
              this.$router.push({
                path: "/card",
                query: { guid: res.data.acCardGuid },
              });
              this.$message({
                type: "success",
                message: "复用成功!",
              });
            }
          }
        );
      });
    },
    // 下载答卷
    down(row) {
      const h = this.$createElement;
      this.$msgbox({
        title: "确认下载",
        message: h("div", null, [
          h(
            "p",
            { style: "color: #aaa;margin-bottom: 10px" },
            "是否确认下载当前答题卡? "
          ),
          h(
            "p",
            { style: "color: #f00" },
            "提示：下载使用考试后请勿修改，否则阅卷设置将无法同步关联"
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        AcCardApi.DownloadAcCard({ CardGuid: row.acCardGuid }).then((res) => {
          if (res.status === 200) {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: "<strong>生成答题卡PDF中,请稍后......</strong>",
              duration: 0,
            });
            let myPdfDom = document.querySelector("#down-pdf");
            console.log("myPdfDom", myPdfDom);
            $(res.data.downStr).appendTo(myPdfDom);
            let myPdfDom1 = document.querySelector("#preview-page");
            setTimeout(() => {
              this.getPdf(myPdfDom1).then((canvas) => {
                let contentWidth = canvas.width;
                let contentHeight = canvas.height;
                if (row.acCardPanesI === 1) {
                  this.savePdfA4(
                    canvas,
                    contentWidth,
                    contentHeight,
                    row.acCardName
                  );
                } else {
                  this.savePdfA3(
                    canvas,
                    contentWidth,
                    contentHeight,
                    row.acCardName
                  );
                }
                $("#down-pdf").empty();
                this.$message.closeAll();
                this.$message({
                  message: "操作成功~",
                  type: "success",
                });
              });
            }, 300);
          }
        });
      });
    },
    savePdfA4(canvas, contentWidth, contentHeight, title) {
      let pageHeight = (contentWidth / 592.28) * 841.89;
      let leftHeight = contentHeight;
      let position = 0;
      let imgWidth = 595.28;
      let imgHeight = (602 / contentWidth) * contentHeight;
      let pageData = canvas.toDataURL("image/jpeg", 1.0);
      let PDF = new JsPDF("", "pt", "a4");
      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
      } else {
        while (leftHeight > 0) {
          PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          if (leftHeight > parseInt(contentHeight / pageHeight) * 18) {
            PDF.addPage();
          }
        }
      }
      PDF.save(title + ".pdf");
    },
    savePdfA3(canvas, contentWidth, contentHeight, title) {
      let pageHeight = (contentWidth / 1191) * 842;
      let leftHeight = contentHeight;
      let position = 0;
      let imgWidth = 1191;
      let imgHeight =
        ((this.answerSheet.acCardPanes === 2 ? 1200 : 1355) / contentWidth) *
        contentHeight;
      let pageData = canvas.toDataURL("image/jpeg", 1.0);
      let PDF = new JsPDF("l", "pt", "a3");
      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
      } else {
        while (leftHeight > 0) {
          const pageLen =  parseInt(contentHeight / pageHeight) *(this.answerSheet.acCardPanes === 2 ? 21 : 0)
          PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 842;
          if (leftHeight > pageLen) {
            PDF.addPage();
          }
        }
      }
      PDF.save(title + ".pdf");
    },
    // 添加答题卡 获取科目、学段 和模板
    addAcCrad() {
      this.acDialogV = true;
    },
    pageCurrentChange(index) {
      this.param.pageIndex = index;
      this.getAcCardList();
    }, //页码改变时
    sizeCurrentChange(size) {
      this.param.pageIndex = 1;
      this.param.pageSize = size;
      this.getAcCardList();
    },
    // indexMethod(index) {
    //   console.log('faf0');
    //   return (this.param.pageIndex-1)*(this.param.pageSize) +(index+1);
    // }
    handleMbAdd(data) {
      this.modalTemplateAddParams = {
        acCardGuid: data.acCardGuid,
        acCardName: data.acCardName,
      }
      this.modalMbAddV = true;
    },
    async handleShare(data) {
      this.modalShareV = true;
      this.modalShareName = data.acCardName;
      const result = await AcCardApi.GetShareCard({
        acCardGuid: data.acCardGuid
      });
      if(result.status == 200) {
        this.modalShareCode = result.data && result.data.ShareCard;
      } else {
        this.$message({
          type: 'error',
          message: result.message
        })
      }
    },
    /**
     * 下载由word导入的答题卡
     * @param {object} data table每一行（row）的数据
     * @returns {void}
     */
    async handlerDownloadWord(data) {
      const result = await AcCardApi.GetFileDoc({
        acGuid: data.acCardGuid
      });
      if(result.status == 200) {
        // 成功
        result.data && (window.location.href =  result.data.url)
      } else {
      }
    },
    handleImport() {
      this.modalImportV = true;
    },
    handleDocUpload() {
      this.modalDocUploadV = true;
    },
    handleSuccessImport() {
      this.param.pageIndex = 1;
      this.getAcCardList();
    }
  },
};
</script>
<style lang="scss">
.container {
  position: relative;
}
.container-pdf {
  position: absolute;
  height: 1000px;
  opacity: 0;
  z-index: -1000;
  overflow-y: hidden;
  .card-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 16px;
    padding: 20px 0;
    text-align: center;
    // font-weight: bold;
    height: 30px;
  }
}
.cont-list {
  width: 80%;
  /*min-height: 820px;*/
  background: #fff;
  margin: 30px 10%;
  padding: 20px;
  position: absolute;
  left: 0;
  top: 50px;
  /* width: 1140px;
     margin: 0 auto;
    background: #fff;
    border: 1px solid #c7c0b6; */
  .el-table {
    color: #333;
  }
  .pagination-card {
    text-align: right;
    padding: 30px;
    .el-pagination__total{
      float: left;
    }
    .el-pagination__sizes{
      float: left;
    }
  }
  .search {
    width: 500px;
    float: right;
    text-align: right;
    /*overflow: ;*/
    .input-with-select {
     float: right;
      width: 240px;
    }
    .button-with-select {
      float: right;
      margin-left: 10px;
    }
  }
  .el-select {
    margin-right: 10px;
  }
  .el-select .el-input {
    width: 120px;
  }
  .el-input-group__prepend {
    background: none;
  }
  .sel-config {
    line-height: 38px;
    border-top: 1px solid #ebeef5;
    .el-checkbox-button__inner {
      border: 0;
      margin: 0 5px;
      &:hover {
        border: 0;
        box-shadow: none;
      }
    }

    .el-checkbox-button--mini .el-checkbox-button__inner,
    .el-checkbox-button.is-checked .el-checkbox-button__inner,
    .el-checkbox-button:first-child .el-checkbox-button__inner,
    .el-checkbox-button:last-child .el-checkbox-button__inner {
      border: 0;
      border-radius: 4px;
      box-shadow: none;
    }
  }
  .pad-t-d {
    padding: 20px 0;
  }
  .ac-list {
    margin-top: 20px;
    border-top: 1px solid #ebeef5;
  }
}
.more-wrap {
  min-width: 62px !important;
  .operation-ul {
    display: flex;
    flex-direction: column;
    margin: 3px 0;
    span{
      color: #409EFF;
      cursor: pointer;
    }
    .mb{
      margin-bottom: 12px;
    }
  }
}
</style>
